export default class KMLHelper {

	static buildFullKMLFromGeometry(id, street, fromStreet, toStreet, geometryString, color, width) {
		return '<?xml version="1.0" encoding="UTF-8"?><kml xmlns="http://www.opengis.net/kml/2.2"><Placemark id="'+id+'"><Style><LineStyle><color>'+color+'</color><width>'+width+'</width></LineStyle></Style><name>'+street+ ' between ' + fromStreet + ' and ' + toStreet + '</name><streetName>'+street+'</streetName><fromStreet>'+fromStreet+'</fromStreet><toStreet>'+toStreet+'</toStreet><visibility>1</visibility><MultiGeometry>'+geometryString+'</MultiGeometry></Placemark></kml>';
	}

	static finalizeKml(placemarkKML) {
		return '<?xml version="1.0" encoding="UTF-8"?><kml xmlns="http://www.opengis.net/kml/2.2">'+placemarkKML+'</kml>';
	}

	static createPlaceMarkFromGeometry(id, street, fromStreet, toStreet, geometryString, color, width) {
		return '<Placemark id="'+id+'"><Style><LineStyle><color>'+color+'</color><width>'+width+'</width></LineStyle></Style><name>'+street+ ' between ' + fromStreet + ' and ' + toStreet + '</name><streetName>'+street+'</streetName><fromStreet>'+fromStreet+'</fromStreet><toStreet>'+toStreet+'</toStreet><visibility>1</visibility><MultiGeometry>'+geometryString+'</MultiGeometry></Placemark>';
	}


}


